<template>
	<div class="overlay-host">
	<Teleport to="body" :disabled="!root">
	<div class="overlay"
		ref="overlay"
		v-show="inDom || visible"
		v-bind="$attrs"
		:aria-label="title"
		:class="[
			overlayClass,
			stateCssClass,
			{ 'overlay--transparentBg' : noBg },
			{ 'overlay--fullScreen' : fullScreen },
			{ 'overlay--mobile' : isMobile },
			{ 'overlay--desktop' : !isMobile }]
		">
		<component :is="tag" class="overlay-container" :class="hasAdditionalInputsSlot && 'additionalInputs-width'"  v-scroll-lock="visible">
			<div v-if="showHeader" class="overlay-header">
				<div v-if="hasHeaderSlot" class="overlay-inner overlay-inner--header">
					<slot name="header" />
				</div>
				<div v-else class="overlay-inner overlay-inner--header">
					<h2 class="overlay-title">{{ title }}</h2>
					<a href="#" class="overlay-closeBtn icon icon--shakespeare icon--cross" @click.prevent="_onCloseClick">Sluiten</a>
				</div>
			</div>

			<div v-if="hasAdditionalInputsSlot">
				<slot name="additionalInputs"/>
			</div>

			<div v-if="hasBodySlot" class="overlay-body">
				<div class="overlay-inner overlay-inner--body">
					<slot name="body"/>
				</div>
			</div>

			<div v-if="hasFooterSlot" class="overlay-footer">
				<div class="overlay-inner overlay-inner--footer">
					<slot name="footer"/>
				</div>
			</div>
		</component>
		<div class="overlay-bg" @click.prevent="_onCloseClick"/>
		<slot name="outsideOverlay" />
	</div>
	</Teleport>
	</div>
</template>

<script src="./Overlay.js"></script>
